<template>
  <MainTemplate>
    <row pt="30px">
      <grid-item xs="2" v-if="!isMobile">
        <aside class="aside">
          <ul>
            <li v-for="(navItem, idx) in asideData" :key="idx">
              <span class="line" v-if="navItem.line"></span>
              <template v-else>
                <span class="green__dot" v-if="idx === 1 && getUser.new_message"></span>
                <router-link
                    exact-active-class="active"
                    :to="{name: navItem.link}">
                  {{ navItem.title }}
                </router-link>
              </template>
            </li>
          </ul>
          <div
              style="position: relative"
              v-if="isShownAsideCalendar"
          >
            <div v-if="dates_loading" class="small-calendar-loader">
              <div class="lds-ring">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
            <v-date-picker
                v-show="!dates_loading"
                ref="calendar"
                color="brown"
                @update:from-page="getDates"
                :value="date"
                :attributes="attributes"
                @dayclick="(e) => $root.$emit('setMainDate', e.date)"
                is-inline
                is-expanded
            />
          </div>

        </aside>
      </grid-item>
      <grid-item xl="10" xs="12">
        <transition name="zoom-fade" :key="$route.name" mode="out-in">
          <router-view></router-view>
        </transition>
      </grid-item>
    </row>
  </MainTemplate>
</template>

<script>
import MainTemplate from '../../../templates/MainTemplate'
import GridItem from '../../../components/grid/GridItem'
import Row from '../../../components/grid/Row'
import SocketMixin from "@/mixins/socket";
import {mapGetters, mapMutations} from "vuex";

export default {
  name: 'App',
  components: {MainTemplate, Row, GridItem},
  mixins: [SocketMixin],
  created() {
    this.$root.$on('setSideDate', (e) => this.setDate(e))
  },
  data: () => ({
    date: new Date(),
    dates_loading: true,
    attributes: [
      {
        highlight: {
          fillMode: 'light',
          contentClass: 'bold',
        },
        dates: []
      },
    ],
    asideData: [
      {link: 'admin.cabinet.calendar', title: 'Календарь'},
      {link: 'admin.cabinet.chat', title: 'Чат'},
      {link: 'admin.cabinet.analytics', title: 'Аналитика'},
      {link: 'admin.cabinet.masters', title: 'Мастера'},
      {link: 'admin.cabinet.client', title: 'Клиенты'},
      {link: 'admin.cabinet.offlinePurchase', title: 'Офлайн покупка'},
    ]
  }),
  beforeMount() {
    this.connectToSocket();
  },
  computed: {
    ...mapGetters(['getUser']),
    isMobile() {
      return document.documentElement.clientWidth < 1170
    },
    isShownAsideCalendar() {
      return this.$route.name === 'admin.cabinet.calendar'
    }
  },
  mounted() {
    this.loadUser();
  },
  methods: {
    ...mapMutations(['setUser']),
    loadUser() {
      this.$api.auth.me().then(({data}) => this.setUser(data));
    },
    getDates(e) {
      this.dates_loading = true;
      this.$api.admin.rent.dates(this.$moment(`${e.year} ${e.month}`, 'YYYY-M').format('YYYY-MM'))
          .then((data) => {
            this.$set(this.attributes[0], 'dates', data.map((item) => {
              return this.$moment(item, 'YYYY-MM-DD').toDate()
            }))
            this.$refs.calendar.move(e)
          }).finally(() => {
        this.dates_loading = false;
      })
    },
    setDate(date) {
      this.date = date
    }
  },
  beforeDestroy() {
    this.$root.$off('setSideDate')
  }
}
</script>

<style lang="scss">
.vc-container {
  --brown-100: #f7fafc;
  --brown-200: transparent;
  --brown-300: #e2e8f0;
  --brown-400: #cbd5e0;
  --brown-500: #a0aec0;
  --brown-600: #B9765B;
  --brown-700: #4a5568;
  --brown-800: #2d3748;
  --brown-900: #1a202c;

}

.vc-grid-container.grid {
  grid-template-columns: repeat(1, minmax(220px, 1fr)) !important;
}
</style>
<style scoped lang="scss">
.small-calendar-loader {
  width: 100%;
  height: 248px;
  background: white;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.04), 0px 0px 2px rgba(0, 0, 0, 0.06), 0px 0px 1px rgba(0, 0, 0, 0.04);
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.lds-ring {
  position: absolute;
  display: inline-block;
  width: 30px;
  height: 30px;
  z-index: 10;
}

.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 30px;
  height: 30px;
  border: 2px solid #DBBFA7;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #DBBFA7 transparent transparent transparent;
}

.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}

.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}

.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}

@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.aside {
  ul {
    list-style: none;

    li {
      margin-bottom: 15px;

      a {
        font-family: "Open Sans", sans-serif;
        text-decoration: none;
        font-size: 16px;
        line-height: 1.5;
        color: #808080;

        &.active {
          font-weight: 600;
          color: #383838;
        }
      }
    }
  }

  .line {
    margin: 20px 0;
    height: 1px;
    width: 100%;
    background: #E5E5E5;
    display: block;
  }
}
</style>
